import { ImpactReport } from 'types/report';
import * as yup from 'yup';

export const getInitialValues = (report: ImpactReport | null) => ({
  id: report?._id || '',
  name: report?.impact?.name || '',
  startDate: report?.impact?.startDate || '',
  endDate: report?.impact?.endDate || '',
  month: report?.impact?.month || '0',
  year: report?.impact?.year || '0',
  wd: report?.impact?.wd.toLocaleString() || '0',
  co2m: report?.impact?.co2m.toLocaleString() || '0',
  wc: report?.impact?.wc.toLocaleString() || '0',
  er: report?.impact?.er.toLocaleString() || '0',
  cos: report?.impact?.cos.toLocaleString() || '0',
  site: report?.site?._id || '',
  customerSiteName: report?.site?.name || '',
  single_use_items: report?.impact?.single_use_items?.toString() || '0',
});

export const validationSchema = yup.object().shape({
  id: yup.string().required('Select Inventory Report'),
  name: yup.string().required('Name is required'),
  startDate: yup.string().required('Start Date is required'),
  endDate: yup.string().required('End Date is required'),
  month: yup.string().required('Month is required'),
  year: yup.string().required('Year is required'),
  wd: yup
    .string()
    .required('Required')
    .test('is-valid-number', 'Must be a valid number', (value) => {
      if (!value) return false;
      const valueWithoutCommas = value.replace(/,/g, ''); // Remove commas
      return !isNaN(Number(valueWithoutCommas));
    }),
  co2m: yup
    .string()
    .required('Required')
    .test('is-valid-number', 'Must be a valid number', (value) => {
      if (!value) return false;
      const valueWithoutCommas = value.replace(/,/g, ''); // Remove commas
      return !isNaN(Number(valueWithoutCommas));
    }),
  wc: yup
    .string()
    .required('Required')
    .test('is-valid-number', 'Must be a valid number', (value) => {
      if (!value) return false;
      const valueWithoutCommas = value.replace(/,/g, ''); // Remove commas
      return !isNaN(Number(valueWithoutCommas));
    }),
  er: yup
    .string()
    .required('Required')
    .test('is-valid-number', 'Must be a valid number', (value) => {
      if (!value) return false;
      const valueWithoutCommas = value.replace(/,/g, ''); // Remove commas
      return !isNaN(Number(valueWithoutCommas));
    }),
  cos: yup
    .string()
    .required('Required')
    .test('is-valid-number', 'Must be a valid number', (value) => {
      if (!value) return false;
      const valueWithoutCommas = value.replace(/,/g, ''); // Remove commas
      return !isNaN(Number(valueWithoutCommas));
    }),
  single_use_items: yup.string().required('Required'),
});
